import { render, staticRenderFns } from "./DashboardQuotes.vue?vue&type=template&id=69a5d516"
import script from "./DashboardQuotes.vue?vue&type=script&lang=ts"
export * from "./DashboardQuotes.vue?vue&type=script&lang=ts"
import style0 from "./DashboardQuotes.vue?vue&type=style&index=0&id=69a5d516&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports